import type { SupportOptions } from "@/features/shell/components/shared/SupportLink";
import { useHelpCenterStore } from "@/features/help-center/stores/helpCenterStore";
import {
  type CustomerLicence,
  CustomerLicenceOptions,
} from "@/features/auth/stores/authStore";

export type Link = {
  name: string;
  action?: () => void;
  href?: string;
  supportOptions?: SupportOptions;
  to?: string;
  nolang?: boolean;
  isVisible?: (licence: CustomerLicence | null) => boolean;
  noSnippet?: boolean;
};

export const LegalLinks: Link[] = [
  {
    name: "Casino Rules",
    supportOptions: { labels: ["weblink-casino-rules"] },
    isVisible: (licence) => {
      return licence === CustomerLicenceOptions.ISLE_OF_MAN;
    },
    noSnippet: true,
  },
  {
    name: "Contest Rules",
    supportOptions: { labels: ["weblink-about-pick-ems"] },
  },
  {
    name: "Betting Rules",
    supportOptions: { labels: ["weblink-general-betting-rules"] },
  },
  {
    name: "Racing Rules",
    supportOptions: { labels: ["weblink-racing-rules"] },
  },
  {
    name: "Customer Query, Dispute & Complaints Policy",
    supportOptions: {
      labels: ["weblink-customer-queries-disputes-and-complaints-policy"],
    },
  },
  {
    name: "Promotion Terms",
    supportOptions: { labels: ["weblink-promotional-terms"] },
  },
];

export const AboutLinks: Link[] = [
  {
    name: "FAQ",
    supportOptions: { labels: ["faq button"] },
  },
  {
    name: "Responsible Gambling Policy",
    supportOptions: { labels: ["weblink-responsible-gambling-policy"] },
  },
  {
    name: "Contact Us",
    action: () => useHelpCenterStore.getState().openHelpCenterChat(),
  },
  {
    name: "About Us",
    to: "/account/about",
  },
];
